import DeleteModal from 'components/ui/Modals/DeleteModal'
import UploadFileModal from 'components/ui/Modals/UploadFileModal'
import FiniquitoErrorModal from 'components/ui/Modals/FiniquitoErrorModal' // ← NUEVO
import EmptyEstadoModal from 'components/ui/Modals/EmptyEstadoModal'
import { useModal } from './ModalContext'

const ModalLookUp = {
  DeleteModal,
  UploadFileModal,
  FiniquitoErrorModal, // ← NUEVO
  EmptyEstadoModal,
}

export default function ModalManager() {
  const { modal, closeModal } = useModal()
  if (!modal) return null
  const Modal = ModalLookUp[modal.name]
  if (!Modal) return null
  return <Modal onClose={closeModal} {...modal.props} />
}